var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, ModalBody, ModalFoot, ModalHead } from '@dixa/lib-shared-habla';
import { useCallback, useState } from 'react';
import { appActions } from 'app/app.actions';
import { analytics } from 'app/utils/segment';
import { QueueSelect } from 'components/queueSelect';
import { createAppModal } from 'utils/modal';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import styles from './conversationQueueTransferModal.module.scss';
/** A component for transferring a conversation to a different queue. */
export const ConversationQueueTransferModal = createAppModal({ type: 'app:conversationQueueTransfer' }, ({ isOpen, modal, hide }) => {
    const dispatch = useAppDispatch();
    const [queue, setQueue] = useState();
    const csid = modal.arg.csid;
    /** Handles closing the transfer to queue modal. */
    const handleClose = useCallback(() => {
        analytics.modalTransferToQueueCancelClicked();
        hide === null || hide === void 0 ? void 0 : hide();
    }, [hide]);
    /** Handles confirming the transfer to queue. */
    const handleConfirm = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!csid || !queue) {
            return;
        }
        analytics.modalTransferToQueueConfirmClicked({
            csid,
            queueId: queue.id,
        });
        dispatch(appActions.conversationTransferRequest.pending({
            request: {
                type: 'internal_queue',
                csid,
                queue,
            },
        }));
        handleClose();
    }), [csid, dispatch, handleClose, queue]);
    return (_jsxs(Modal, Object.assign({ isOpen: isOpen, onClose: handleClose, className: styles.modal }, { children: [_jsx(ModalHead, { title: `Transfer ${csid} to a different queue`, onClose: handleClose }), _jsx(ModalBody, { children: _jsx(QueueSelect, { selectedQueue: queue, onSelect: setQueue }) }), _jsx(ModalFoot, { cancelOnClick: handleClose, confirmName: "Transfer", confirmProps: {
                    disabled: !queue,
                }, confirmOnClick: handleConfirm })] })));
});
